import { forwardRef } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const StatusBar = forwardRef(
  ({ type = null, children, closeHandler = null }, ref) => {
    let colorClass = 'bg-gray-700';
    let icon = null;

    if (type === 'success') {
      icon = <CheckCircleOutlineIcon />;
      colorClass = 'bg-green-700';
    } else if (type === 'error') {
      icon = <ErrorOutlineIcon />;
      colorClass = 'bg-red-700';
    }

    return (
      <div
        className={`rounded-md ${colorClass} flex items-center p-2 text-white`}
        ref={ref}
      >
        {icon && <span className='pr-2'>{icon}</span>}
        {children}
        {closeHandler && (
          <span className='pl-4'>
            <IconButton
              size='small'
              aria-label='close'
              color='inherit'
              onClick={closeHandler}
            >
              <CloseIcon fontSize='small' />
            </IconButton>
          </span>
        )}
      </div>
    );
  }
);

export default StatusBar;
